import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const ReviewStep = ({ formData, set }) => (
  <div className="space-y-4" data-testid="step-review">
    <h3 className="text-xl font-semibold mb-2 text-emerald-800">
      Additional Information &amp; Review
    </h3>
    <div>
      <Label htmlFor="yearEnd">Financial Year End</Label>
      <Input
        id="yearEnd"
        type="date"
        value={formData.financialYearEnd}
        onChange={(e) => set('financialYearEnd', e.target.value)}
      />
    </div>
    <div>
      <Label htmlFor="officer">Public Officer (Optional)</Label>
      <Input
        id="officer"
        value={formData.publicOfficer}
        onChange={(e) => set('publicOfficer', e.target.value)}
      />
    </div>
    <div>
      <Label>Preferred Contact Method</Label>
      <select
        value={formData.preferredContactMethod}
        onChange={(e) => set('preferredContactMethod', e.target.value)}
        className="w-full p-2 border border-gray-300 rounded-md"
      >
        <option value="email">Email</option>
        <option value="phone">Phone</option>
        <option value="both">Both</option>
      </select>
    </div>
    <Card className="bg-emerald-50 border-emerald-200 mt-4">
      <CardHeader>
        <CardTitle className="text-emerald-800">Application Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        <p>
          <strong>1st Name:</strong> {formData.proposedName1 || '—'}
        </p>
        {formData.proposedName2 && (
          <p>
            <strong>2nd:</strong> {formData.proposedName2}
          </p>
        )}
        <p>
          <strong>Directors:</strong> {formData.directors.length}
        </p>
        <p>
          <strong>Shareholders:</strong> {formData.shareholders.length}
        </p>
      </CardContent>
    </Card>
  </div>
);

export default ReviewStep;
